var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',[(_vm.previewPath)?_c('div',{staticClass:"image-container mb-3"},[_c('img',{attrs:{"src":_vm.previewPath,"alt":"Uploaded Image Preview"}})]):_vm._e(),_c('div',{staticClass:"form-group"},[_c('div',{ref:"dashboardContainer"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }